import { CheckCircle2 } from "lucide-react";
import { TRUST_BADGES } from "../lib/business";

export default function TrustBadges({ variant = "light" }) {
  const isDark = variant === "dark";
  return (
    <ul
      data-testid="trust-badges"
      className="flex flex-wrap gap-2 sm:gap-3 mt-6"
    >
      {TRUST_BADGES.map((b) => (
        <li
          key={b}
          className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-semibold ${
            isDark
              ? "bg-white/10 border border-white/20 text-white"
              : "bg-secondary border border-border text-primary"
          }`}
        >
          <CheckCircle2 size={14} className="text-accent" />
          {b}
        </li>
      ))}
    </ul>
  );
}
